export * from "./contract-assignment-subletting.component";
export * from "./contract-break-clause.component";
export * from "./contract-detail.component";
export * from "./contract-demarcation-list.component";
export * from "./contract-escalation-clause.component";
export * from "./contract-extension.component";
export * from "./contract-general-contract-info.component";
export * from "./contract-general-info.component";
export * from "./contract-rent-charges.component";
export * from "./contract-rent-deduction.component";
export * from "./contract-term-possession.component";
export * from "./contract-document.component";

export * from './contract-simplified.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/index.ts